export default __webpack_public_path__ + "static/media/cloudy-night-1.4e6a9fde.svg";